import { authStore, authSubject } from '../store/authStore';
import api from '../api/api';

export const AuthFacade = {
    // Expõe o estado como um Observable para os componentes (Requisito 5.13.e)
    authState$: authSubject.asObservable(),

    /**
     * Lógica de login centralizada (Padrão Facade - Requisito Sênior)
     */
    async login(login: string, senha: string): Promise<boolean> {
        console.log(`[AuthFacade] Tentando realizar login para o usuário: "${login}"`);
        console.log(`[AuthFacade] URL Base da API configurada: "${api.defaults.baseURL || 'não definida'}"`);
        try {
            const response = await api.post('/api/v1/auth/login', { login, senha });
            console.log(`[AuthFacade] Resposta da API recebida com status: ${response.status}`);

            // TRATAMENTO SÊNIOR:
            // Verificamos se o token veio como string direta ou dentro de um objeto
            const token = typeof response.data === 'string'
                ? response.data
                : response.data.token;

            if (token) {
                console.log("[AuthFacade] Token recuperado com sucesso. Salvando no estado.");
                // Salva apenas a string bruta do JWT no LocalStorage
                authStore.login(token);
                return true;
            }

            console.error("[AuthFacade] Token não encontrado no corpo da resposta da API:", response.data);
            return false;

        } catch (error: any) {
            console.error("[AuthFacade] Erro capturado no fluxo de autenticação:");
            if (error.response) {
                console.error(`  - Status Code: ${error.response.status}`);
                console.error("  - Dados de erro retornados pela API:", error.response.data);
            } else if (error.request) {
                console.error("  - Nenhuma resposta recebida do servidor. Verifique se o backend está rodando localmente.");
                console.error("  - Detalhes da requisição pendente:", error.request);
            } else {
                console.error(`  - Mensagem de erro geral: ${error.message}`);
            }
            return false;
        }
    },

    /**
     * Logout centralizado
     */
    logout() {
        authStore.logout();
        window.location.href = '/';
    }
};